import { makeStyles, tokens } from '@fluentui/react-components';

export const useConceptSponsorDetailsStyles = makeStyles({
  fieldGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalL}`
  },
  fullRow: {
    gridColumn: '1 / -1'
  },
  previousCost: {
    color: tokens.colorNeutralForeground4
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS
  },
  fieldLabel: {
    color: tokens.colorNeutralForeground3
  },
  fieldValue: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS
  },
  costValue: {
    fontWeight: tokens.fontWeightSemibold
  },
  historyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS
  },
  historyItem: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalM}`,
    padding: tokens.spacingVerticalS,
    borderRadius: tokens.borderRadiusMedium,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground2
  },
  historyDate: {
    color: tokens.colorNeutralForeground3,
    gridColumn: '1 / -1',
    borderBottom: `1px solid ${tokens.colorNeutralStroke3}`,
    paddingBottom: tokens.spacingVerticalXXS,
    marginBottom: tokens.spacingVerticalXXS
  },
  historyCosts: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalL}`,
    gridColumn: '1 / -1'
  },
  historyCostField: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    minWidth: '140px'
  },
  historyArrow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    flexWrap: 'wrap'
  }
});
